import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { CardHeader } from 'components/common';
import { Namespace } from 'enums';

import { HeaderMoreInfo } from './HeaderMoreInfo';
import { HeaderGuideInfo } from './HeaderGuideInfo';

interface Props {
  createRequest?: () => void;
}

export const HomeHeader = ({ createRequest }: Props) => {
  const { t } = useTranslation(Namespace.PersonalArea);

  return (
    <CardHeader>
      <div>
        <h2 className="card-title" style={{ marginBottom: '0' }}>
          {t('myRequests')}
        </h2>
        <HeaderMoreInfo />
        <HeaderGuideInfo />
      </div>
      <Button type="primary" onClick={createRequest}>
        {t('createRequest')}
      </Button>
    </CardHeader>
  );
};
